"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoutingRpcCommunicator = void 0;
const uuid_1 = require("uuid");
const proto_rpc_1 = require("@streamr/proto-rpc");
const DhtCallContext_1 = require("../rpc-protocol/DhtCallContext");
const ITransport_1 = require("./ITransport");
class RoutingRpcCommunicator extends proto_rpc_1.RpcCommunicator {
    ownServiceId;
    constructor(ownServiceId, sendFn, options) {
        super(options);
        this.ownServiceId = ownServiceId;
        this.setOutgoingMessageListener((msg, _requestId, callContext) => {
            let targetDescriptor;
            // rpc call message
            if (callContext.targetDescriptor) {
                targetDescriptor = callContext.targetDescriptor;
            }
            else { // rpc reply message
                targetDescriptor = callContext.incomingSourceDescriptor;
            }
            const message = {
                messageId: (0, uuid_1.v4)(),
                serviceId: this.ownServiceId,
                body: {
                    oneofKind: 'rpcMessage',
                    rpcMessage: msg
                },
                targetDescriptor
            };
            // TODO maybe sendOptions could be a separate block inside callContext
            const sendOpts = (msg.header.response !== undefined)
                ? {
                    // typically we already have a connection, but if it has disconnected for some reason
                    // the receiver could have gone offline (or it is no longer a neighbor) and therefore there
                    // is no point in trying form a new connection
                    connect: false,
                    // TODO maybe this options could be removed?
                    sendIfStopped: true,
                    // Responses should be buffered if necessary
                    doNotBufferWhileConnecting: false
                } : {
                connect: callContext?.connect ?? ITransport_1.DEFAULT_SEND_OPTIONS.connect,
                sendIfStopped: callContext?.sendIfStopped ?? ITransport_1.DEFAULT_SEND_OPTIONS.sendIfStopped,
                doNotBufferWhileConnecting: callContext?.doNotBufferWhileConnecting ?? ITransport_1.DEFAULT_SEND_OPTIONS.doNotBufferWhileConnecting
            };
            return sendFn(message, sendOpts);
        });
    }
    handleMessageFromPeer(message) {
        if (message.serviceId === this.ownServiceId && message.body.oneofKind === 'rpcMessage') {
            const context = new DhtCallContext_1.DhtCallContext();
            context.incomingSourceDescriptor = message.sourceDescriptor;
            // TODO should we have some handling for this floating promise?
            this.handleIncomingMessage(message.body.rpcMessage, context);
        }
    }
}
exports.RoutingRpcCommunicator = RoutingRpcCommunicator;
//# sourceMappingURL=RoutingRpcCommunicator.js.map